<p
  i18n="@@profileView.editDialog.basicInfo.subtitle"
  class="text-subtitle-1 u-marginBottom-8"
>
  Basic information
</p>
<ng-container *ngIf="(profile | appAccountJobTitle) || isUser">
  <div class="u-marginBottom-8" fxLayout="row" fxLayoutAlign="start center">
    <mat-icon class="color-grey-300" fxFlex="24px" matTooltip="Job experience"
      >work</mat-icon
    >
    <div class="u-overflow-hidden u-paddingLeft-8">
      <div class="u-wordWrap-breakWord u-text-maxWidth color-grey">
        <p i18n="@@profileView.basicInformation.workLabel">
          {{ profile | appAccountJobTitle
          }}<ng-container
            *ngIf="
              (profile | appAccountJobTitle) &&
              (profile | appAccountOrganizationName)
            "
            >&nbsp;at</ng-container
          >
          <ng-container *ngIf="profile | appAccountOrganizationName">
            {{ profile | appAccountOrganizationName }}
          </ng-container>
        </p>
      </div>
      <div
        *ngIf="
          !(profile | appAccountJobTitle) &&
          !(profile | appAccountOrganizationName) &&
          isUser
        "
        class="u-paddingLeft-8"
      >
        <button
          i18n="@@profileView.basicInformation.addWork.label"
          (click)="editProfile('inputExperienceJobTitle')"
          class="c-button color-blue u-textDecoration-underline--hover"
        >
          Add what you do and where you work
        </button>
      </div>
    </div>
  </div>
</ng-container>
<ng-container *ngIf="tenant?.auth?.linkedin">
  <ng-container
    *ngIf="profile.social_accounts?.linkedin?.profile_url || isUser"
  >
    <div
      *ngIf="profile.social_accounts?.linkedin?.profile_url as linkedInUrl"
      class="u-marginBottom-8"
      fxLayout="row"
      fxLayoutAlign="start center"
    >
      <mat-icon class="color-grey-300" matTooltip="LinkedIn profile"
        >LinkedIn</mat-icon
      >
      <div class="u-paddingLeft-8">
        <ng-container>
          <a
            i18n="@@profileView.basicInformation.linkedIn.linkLabel"
            [href]="linkedInUrl | appLinkify"
            class="color-blue"
            target="_blank"
          >
            LinkedIn profile
          </a>
        </ng-container>
      </div>
    </div>
  </ng-container>
</ng-container>
<ng-container *ngIf="isUser || profile.website">
  <div class="u-marginBottom-8" fxLayout="row" fxLayoutAlign="start center">
    <mat-icon class="color-grey-300" fxFlex="32px" matTooltip="Website">
      public
    </mat-icon>
    <a
      *ngIf="profile.website"
      [href]="profile.website | appLinkify"
      class="u-wordWrap-breakWord color-blue u-textDecoration-underline--hover"
      fxFlex="calc(100% - 32px)"
      target="_blank"
    >
      {{ profile.website }}
    </a>
    <div *ngIf="!profile.website && isUser">
      <button
        i18n="@@profileView.basicInformation.addWebsite.label"
        (click)="editProfile('inputWebsite')"
        class="c-button color-blue u-textDecoration-underline--hover"
      >
        Add a website where others can find out more about you
      </button>
    </div>
  </div>
</ng-container>
<ng-container *ngIf="isUser || (profile | appAccountGeoLocationAddress)">
  <div class="u-marginBottom-8" fxLayout="row" fxLayoutAlign="start center">
    <mat-icon class="color-grey-300" fxFlex="32px" matTooltip="Location">
      location_on
    </mat-icon>
    <p
      *ngIf="profile | appAccountGeoLocationAddress as accountAddress"
      class="u-wordWrap-breakWord"
      fxFlex="calc(100% - 32px)"
    >
      {{ accountAddress }}
    </p>
    <div
      *ngIf="!(profile | appAccountGeoLocationAddress) && isUser"
      fxFlex="calc(100% - 32px)"
    >
      <button
        i18n="@@profileView.basicInformation.addLocation.label"
        (click)="editProfile('inputLocation')"
        class="c-button color-blue u-textDecoration-underline--hover"
      >
        Add your location
      </button>
    </div>
  </div>
</ng-container>
<ng-container
  *ngIf="
    (isUser ||
      (!!profile.education && profile.education[0]
        | accountReadableEducation)) &&
    !tenant?.hidden_base_profile_fields?.education
  "
>
  <div class="u-marginBottom-8" fxLayout="row" fxLayoutAlign="start center">
    <mat-icon class="color-grey-300" fxFlex="32px" matTooltip="School">
      school
    </mat-icon>
    <p
      *ngIf="
        !!profile.education && profile.education[0] | accountReadableEducation
      "
      class="u-wordWrap-breakWord"
      fxFlex="calc(100% - 32px)"
    >
      {{
        !!profile.education && profile.education[0] | accountReadableEducation
      }}
    </p>
    <div
      *ngIf="
        !(
          !!profile.education && profile.education[0] | accountReadableEducation
        ) && isUser
      "
      fxFlex="calc(100% - 32px)"
    >
      <button
        i18n="@@profileView.basicInformation.addSchool.label"
        (click)="editProfile('inputSchoolProgram')"
        class="c-button color-blue u-textDecoration-underline--hover"
      >
        Add where you went to school
      </button>
    </div>
  </div>
</ng-container>
